// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/billing/v1/get_storage_breakdown.proto (package protos.vision.billing.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/billing/v1/get_storage_breakdown.proto.
 */
export const file_vision_billing_v1_get_storage_breakdown: GenFile = /*@__PURE__*/
  fileDesc("Ci12aXNpb24vYmlsbGluZy92MS9nZXRfc3RvcmFnZV9icmVha2Rvd24ucHJvdG8SGHByb3Rvcy52aXNpb24uYmlsbGluZy52MSJzChpHZXRTdG9yYWdlQnJlYWtkb3duUmVxdWVzdBJLCgZwYXJhbXMYASABKAsyOy5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuR2V0U3RvcmFnZUJyZWFrZG93blJlcXVlc3QuUGFyYW1zGggKBlBhcmFtcyKLAgobR2V0U3RvcmFnZUJyZWFrZG93blJlc3BvbnNlEkwKBnJlc3VsdBgBIAEoCzI8LnByb3Rvcy52aXNpb24uYmlsbGluZy52MS5HZXRTdG9yYWdlQnJlYWtkb3duUmVzcG9uc2UuUmVzdWx0Gp0BCgZSZXN1bHQSGgoSc3RvcmFnZV91c2VkX2J5dGVzGAEgASgDEhsKE3N0b3JhZ2VfbGltaXRfYnl0ZXMYAiABKAMSOgoIcHJvamVjdHMYAyADKAsyKC5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuUHJvamVjdFN0b3JhZ2USHgoWcGVyc29uYWxfc3RvcmFnZV9ieXRlcxgEIAEoAyJOCg5Qcm9qZWN0U3RvcmFnZRISCgpwcm9qZWN0X2lkGAEgASgJEgwKBG5hbWUYAiABKAkSGgoSc3RvcmFnZV91c2VkX2J5dGVzGAMgASgDYgZwcm90bzM");

/**
 * @generated from message protos.vision.billing.v1.GetStorageBreakdownRequest
 */
export type GetStorageBreakdownRequest = Message<"protos.vision.billing.v1.GetStorageBreakdownRequest"> & {
  /**
   * @generated from field: protos.vision.billing.v1.GetStorageBreakdownRequest.Params params = 1;
   */
  params?: GetStorageBreakdownRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.GetStorageBreakdownRequest.
 * Use `create(GetStorageBreakdownRequestSchema)` to create a new message.
 */
export const GetStorageBreakdownRequestSchema: GenMessage<GetStorageBreakdownRequest> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_get_storage_breakdown, 0);

/**
 * @generated from message protos.vision.billing.v1.GetStorageBreakdownRequest.Params
 */
export type GetStorageBreakdownRequest_Params = Message<"protos.vision.billing.v1.GetStorageBreakdownRequest.Params"> & {
};

/**
 * Describes the message protos.vision.billing.v1.GetStorageBreakdownRequest.Params.
 * Use `create(GetStorageBreakdownRequest_ParamsSchema)` to create a new message.
 */
export const GetStorageBreakdownRequest_ParamsSchema: GenMessage<GetStorageBreakdownRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_get_storage_breakdown, 0, 0);

/**
 * @generated from message protos.vision.billing.v1.GetStorageBreakdownResponse
 */
export type GetStorageBreakdownResponse = Message<"protos.vision.billing.v1.GetStorageBreakdownResponse"> & {
  /**
   * @generated from field: protos.vision.billing.v1.GetStorageBreakdownResponse.Result result = 1;
   */
  result?: GetStorageBreakdownResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.GetStorageBreakdownResponse.
 * Use `create(GetStorageBreakdownResponseSchema)` to create a new message.
 */
export const GetStorageBreakdownResponseSchema: GenMessage<GetStorageBreakdownResponse> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_get_storage_breakdown, 1);

/**
 * @generated from message protos.vision.billing.v1.GetStorageBreakdownResponse.Result
 */
export type GetStorageBreakdownResponse_Result = Message<"protos.vision.billing.v1.GetStorageBreakdownResponse.Result"> & {
  /**
   * @generated from field: int64 storage_used_bytes = 1;
   */
  storageUsedBytes: bigint;

  /**
   * @generated from field: int64 storage_limit_bytes = 2;
   */
  storageLimitBytes: bigint;

  /**
   * @generated from field: repeated protos.vision.billing.v1.ProjectStorage projects = 3;
   */
  projects: ProjectStorage[];

  /**
   * @generated from field: int64 personal_storage_bytes = 4;
   */
  personalStorageBytes: bigint;
};

/**
 * Describes the message protos.vision.billing.v1.GetStorageBreakdownResponse.Result.
 * Use `create(GetStorageBreakdownResponse_ResultSchema)` to create a new message.
 */
export const GetStorageBreakdownResponse_ResultSchema: GenMessage<GetStorageBreakdownResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_get_storage_breakdown, 1, 0);

/**
 * @generated from message protos.vision.billing.v1.ProjectStorage
 */
export type ProjectStorage = Message<"protos.vision.billing.v1.ProjectStorage"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int64 storage_used_bytes = 3;
   */
  storageUsedBytes: bigint;
};

/**
 * Describes the message protos.vision.billing.v1.ProjectStorage.
 * Use `create(ProjectStorageSchema)` to create a new message.
 */
export const ProjectStorageSchema: GenMessage<ProjectStorage> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_get_storage_breakdown, 2);

